import * as S from './styles'

const EmptyBox = ({ children }) => {
  return (
    <>
      <S.ProfileBox>
        <div className="description text-center">{children}</div>
      </S.ProfileBox>
    </>
  )
}

export default EmptyBox
